

export interface IMedicalRecordAllele {
    locusGroup: number,
    locusGroupIndex: 1 | 2,
    alleleDetail: string,
    noMismatch: boolean,
    isExpressed: boolean,
    primaryEquivalent: number | null,
    serologicalEquivalents: number[]
}